import Model from './Model';

export default class Promo extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'promos';
  }
}
